import React from "react";
import { Helmet } from "react-helmet-async";

export default function DefaultSEO() {
  return (
    <Helmet>
      <title>Buddi</title>
      <meta property="og:title" content="Buddi"/>
      <meta property="og:image" content="%PUBLIC_URL%/images/Buddi-Generic-BG.jpg"/>
    </Helmet>
  );
}